export function browser() {
  const { userAgent } = navigator;
  let tem;
  let M;
  M =
    userAgent.match(/(edg(?=\/))\/?\s*(\d+)/i) ||
    userAgent.match(/(opera|chrome|safari|firefox|trident(?=\/))\/?\s*(\d+)/i) ||
    [];

  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(userAgent) || [];
    return `IE ${tem[1] || ''}`;
  }
  if (M[1] === 'Chrome' || M[1] === 'EDG') {
    tem = userAgent.match(/\bOPR\/(\d+)/);
    if (tem != null) {
      return `Opera ${tem[1]}`;
    }
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
  // eslint-disable-next-line no-cond-assign
  if ((tem = userAgent.match(/version\/(\d+)/i)) != null) {
    M.splice(1, 1, tem[1]);
  }

  return M[0];
}
export function browserVersion(browser) {
  let userAgent = navigator.userAgent.toLowerCase();
  let version = '0';
  browser = browser.toLowerCase();
  // Edge
  if (browser == 'edg') {
    userAgent = userAgent.substring(userAgent.indexOf('edg/') + 4);
    version = userAgent;
  }
  // Chrome
  if (browser == 'chrome') {
    userAgent = userAgent.substring(userAgent.indexOf('chrome/') + 7);
    userAgent = userAgent.substring(0, userAgent.indexOf(' '));
    version = userAgent;
  }
  // Safari
  if (browser == 'safari') {
    userAgent = userAgent.substring(userAgent.indexOf('version/') + 8);
    userAgent = userAgent.substring(0, userAgent.indexOf(' '));
    version = userAgent;
  }
  // Mozilla
  if (browser == 'mozilla' || browser == 'firefox') {
    // Firefox
    if (navigator.userAgent.toLowerCase().indexOf('firefox') != -1) {
      userAgent = userAgent.substring(userAgent.indexOf('firefox/') + 8);
      // userAgent = userAgent.substring(0, userAgent.indexOf(' '));
      version = userAgent;
    }
  }
  // Opera?
  if (browser == 'opera') {
    userAgent = userAgent.substring(userAgent.indexOf('version/') + 8);
    version = userAgent;
  }
  return version;
}
